module.exports = __webpack_public_path__ + "img/assigned.9d290943.svg";